import { Link, Route } from "react-router-dom";
import React from "react";
import AuthMiddleware from "../middleware/AuthMiddleware";
import { useSelector } from "react-redux";
import { checkPermission } from "./RouteValidator";
import AddExpense from "../../modules/account/AddExpense";
import ManageExpenses from "../../modules/account/ManageExpenses";
import UpdateExpense from "../../modules/account/UpdateExpense";
import AddVoucher from "../../modules/account/AddVoucher";
import ManageVouchers from "../../modules/account/ManageVouchers";
import UpdateVoucher from "../../modules/account/UpdateVoucher";

const GenerateAccountModuleRoutes = () => {
  const company = useSelector((state: any) => state.company);
  const auth = useSelector((state: any) => state.auth);

  const routes: any = [];

  // Expenses
  if (checkPermission(auth, company, "/expenses/add")) {
    routes.push(
      <Route
        path={"/expenses/add"}
        element={<AuthMiddleware children={<AddExpense />} />}
      />
    );
  }

  if (checkPermission(auth, company, "/expenses")) {
    routes.push(
      <Route
        path={"/expenses"}
        element={<AuthMiddleware children={<ManageExpenses />} />}
      />
    );
  }

  if (checkPermission(auth, company, "/expenses/details/id")) {
    routes.push(
      <Route
        path={"/expenses/details/:id"}
        element={<AuthMiddleware children={<UpdateExpense />} />}
      />
    );
  }

  // Receipt Vouchers
  if (checkPermission(auth, company, "/receipt-vouchers/add")) {
    routes.push(
      <Route
        path={"/receipt-vouchers/add"}
        element={<AuthMiddleware children={<AddVoucher />} />}
      />
    );
  }

  if (checkPermission(auth, company, "/receipt-vouchers")) {
    routes.push(
      <Route
        path={"/receipt-vouchers"}
        element={<AuthMiddleware children={<ManageVouchers />} />}
      />
    );
  }

  if (checkPermission(auth, company, '/receipt-vouchers/details/id')) {
      routes.push(
          <Route path={'/receipt-vouchers/details/:id'} element={
              <AuthMiddleware children={<UpdateVoucher/>}/>
          }/>
      );
  }

  // Payment Vouchers
  if (checkPermission(auth, company, "/payment-vouchers/add")) {
    routes.push(
      <Route
        path={"/payment-vouchers/add"}
        element={<AuthMiddleware children={<AddVoucher />} />}
      />
    );
  }

  if (checkPermission(auth, company, "/payment-vouchers")) {
    routes.push(
      <Route
        path={"/payment-vouchers"}
        element={<AuthMiddleware children={<ManageVouchers />} />}
      />
    );
  }

  if (checkPermission(auth, company, '/payment-vouchers/details/id')) {
    routes.push(
        <Route path={'/payment-vouchers/details/:id'} element={
            <AuthMiddleware children={<UpdateVoucher/>}/>
        }/>
    );
}

  return routes;
};

export default GenerateAccountModuleRoutes;
